import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import Manipulator from '../../utils/dom/manipulator';
import Request from '../../utils/request';
class CourseDetails {
	constructor() {
		const wrapperComponent = SelectorEngine.findOne('.js-course-details');
		this.waitingListText = SelectorEngine.find('.js-waiting-list-text');
		this.waitingListLoader = SelectorEngine.findOne('.js-waiting-list-loader');
		if (wrapperComponent) {
			this.init();
		}
	}

	init() {
		const joinButtons = SelectorEngine.find('.js-course-details-waiting-list');
		for (const joinButton of joinButtons) {
			EventHandler.on(joinButton, 'click', async () => {
				const { url } = Manipulator.getDataAttributes(joinButton);
				try {
					this.showLoader();
					const apiResponse = await Request.post(url, {});
					if (apiResponse.Success) {
						this.waitingListSuccess();
					} else {
						this.waitingListError();
					}
				} catch {
					this.waitingListError();
				}
				this.hideLoader();
			});
		}
	}

	showLoader() {
		for (const text of this.waitingListText) {
			text.classList.add('u-hidden');
		}
		this.waitingListLoader.classList.remove('u-hidden');
	}

	hideLoader() {
		for (const text of this.waitingListText) {
			text.classList.remove('u-hidden');
		}
		this.waitingListLoader.classList.add('u-hidden');
	}

	waitingListSuccess() {
		const courseDetailsMessage = SelectorEngine.findOne('.js-course-details-message');
		const successTexts = SelectorEngine.find('.js-course-details-success-text');
		const fullTexts = SelectorEngine.find('.js-course-details-full-text');

		for (const successText of successTexts) {
			successText.classList.remove('u-hidden');
		}
		for (const successText of successTexts) {
			successText.classList.remove('u-hidden');
		}
		for (const fullText of fullTexts) {
			fullText.classList.add('u-hidden');
		}
		courseDetailsMessage.classList.add('is-visible');
		EventHandler.one(courseDetailsMessage, 'animationend', (e) => {
			e.target.classList.remove('is-visible');
		});
	}

	waitingListError() {
		const courseDetailsMessage = SelectorEngine.findOne('.js-course-details-message-error');

		courseDetailsMessage.classList.add('is-visible');
		EventHandler.one(courseDetailsMessage, 'animationend', (e) => {
			e.target.classList.remove('is-visible');
		});
	}
}

const globalCourseDetails = new CourseDetails();

export default globalCourseDetails;
